@if (
  {
    isDiscoverable: isDiscoverable$ | async,
    isVerified: isVerified$ | async,
  };
  as data
) {
  <!-- #TODO refactor -->
  @if (!data.isVerified) {
    <div [class.compact]="compact" class="empty">
      <img
        src="../../../../assets/network-empty.png"
        alt="No results"
        width="128"
        height="128"
      />
      @if (compact) {
        <div>
          <h4 class="mat-body-2">Get suggestions</h4>
          <p class="mat-body">
            Verify your identity or workspace to get suggestions and search the
            network.
          </p>
          <a class="celo-link" (click)="verifyIdentity()">
            <button mat-button>Verify Identity</button>
          </a>
        </div>
      } @else {
        <h4 class="mat-body-2">Get suggestions</h4>
        <p class="mat-body">
          Verify your identity or workspace to get suggestions and search the
          network.
        </p>
        <a class="celo-link" (click)="verifyIdentity()">
          <button mat-button>Verify Identity</button>
        </a>
      }
    </div>
  }
  @if (data.isVerified && !data.isDiscoverable) {
    <div [class.compact]="compact" class="empty">
      <img
        src="../../../../assets/network-empty.png"
        alt="No results"
        width="128"
        height="128"
      />
      @if (compact) {
        <div>
          <h4 class="mat-body-2">Join the Celo community</h4>
          <p class="mat-body">
            You can get suggestions and search the network by becoming
            discoverable.
          </p>
          <a class="celo-link" routerLink="/edit/privacy">
            <button mat-button>Go to settings</button>
          </a>
        </div>
      } @else {
        <h4 class="mat-body-2">Join the Celo community</h4>
        <p class="mat-body">
          You can get suggestions and search the network by becoming
          discoverable.
        </p>
        <a class="celo-link" routerLink="/edit/privacy">
          <button mat-button>Go to settings</button>
        </a>
      }
    </div>
  }
}
